export default __webpack_public_path__ + "static/media/walletConnectionIcon.53f7bbd0.svg";